// extracted by mini-css-extract-plugin
export default {"content":"_3u8SJ","day":"jkJ1d","past":"_30H_i","dayText":"_1lY8Y","today":"uzsIr","events":"_16cvI","event":"Yqy2m"};